import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('commission');

export class WeekObjetive extends Api {
    constructor(http, config = {}) {
        super(http, url, 'weekObjetive', config);
    }
}